import React, { Fragment, Component } from 'react';
import {
    ArrayField,
    BulkDeleteButton,
    Datagrid,
    EmailField,
    Filter,
    List,
    NumberField,
    Pagination,
    ReferenceInput,
    SelectInput,
    ShowButton,
    Show,
    SimpleShowLayout,
    TextInput,
    TextField,
    UrlField,
} from 'react-admin';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import SubmitButton from './SubmitButton'
import Icon from '@material-ui/icons/Bookmark';
export const ConfigIcon = Icon;


const ConfigBulkActionButtons = props => (
    <Fragment>
        <BulkDeleteButton {...props} />
    </Fragment>
);

export const ConfigFilter = props => (
    <Filter {...props}>
        <SelectInput
            source="Period"
            label={"Period"}
            alwaysOn
            choices={[
                { id: 'Last 24 hours', name: 'Last 24 hours'},
                { id: 'Last 3 days', name: 'Last 3 days'},
                { id: 'Last week', name: 'Last week' },
            ]} />
        <ReferenceInput
            source="UserId"
            alwaysOn
            reference="user"
            sort={{ field: 'UserId', order: 'ASC' }}
        >
            <SelectInput optionText="UserId" />
        </ReferenceInput>
        <TextInput
            label={"Customer Name"}
            source="CustomerName"
            alwaysOn
        />
        <TextInput
            label={"Search Description"}
            source={"CustomerConfigDescription"}
            alwaysOn
        />
        <SelectInput
            source="DensityTestStatus"
            label={"Status"}
            alwaysOn
            choices={[
                { id: 'Deploying vDCM', name: 'Deploying vDCM'},
                { id: 'Wait for Submit', name: 'Wait for Submit'},
                { id: 'Testing', name: 'Testing' },
                { id: 'Done', name: 'Done' },
                { id: 'WaitForTestSystem', name: 'WaitForTestSystem' },
                { id: 'OnHold', name: 'OnHold' },
                { id: 'RegressionTest', name: 'RegressionTest' },
        ]} />
    </Filter>
);

const ConfigExpand = props => (
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    >
        <SimpleShowLayout>
            <ArrayField label="Test Results" source="Dut">
                <Datagrid>
                    <TextField
                        label="Synamedia PID"
                        source="VNNode"
                        sortable={false}/>
                    <TextField
                        label="CPU Architecture"
                        source="ModelName"
                        sortable={false}/>
                    <TextField
                        label="OS Version"
                        source="OSVersion"
                        sortable={false}/>
                    <TextField
                        label="SW Version"
                        source="SourceVersion"
                        sortable={false}/>
                    <TextField
                        label="Testing Density"
                        source="TestingDensity"
                        sortable={false}/>
                    <TextField
                        label="Highest Pass"
                        source="HighestPass"
                        sortable={false}/>
                    <TextField
                        label="Lowest Fail"
                        source="LowestFail"
                        sortable={false}/>
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
);

const ConfigPagination = props => <Pagination perPage={5} rowsPerPageOptions={[5, 10]} {...props} />;


class ConfigList extends Component {
    render() {
        const props = this.props;
        return (
            <Fragment>
                <List title={<ConfigTitle />}  {...props}
                      filters={<ConfigFilter />}
                      filterDefaultValues={{
                          Period: 'Last 24 hours'}}
                      sort={{ field: 'Created', order: 'DESC' }}
                      bulkActionButtons={<ConfigBulkActionButtons />}
                      exporter={false}
                      pagination={<ConfigPagination />}
                >
                    <Datagrid expand={<ConfigExpand />}>
                        <TextField
                            label="Created [UTC]"
                            source={"Created"} />
                        <EmailField
                            label={"User"}
                            source={"UserId"}
                            sortable={false} />
                        <TextField
                            source={"CustomerName"}
                            sortable={false}/>
                        <TextField
                            label="Description"
                            source="CustomerConfigDescription"
                            sortable={false} />
                        <NumberField
                            label="Max CPU load [%]"
                            source="MaxCPU"
                            sortable={false}/>
                        <UrlField
                            label="vDCM Username Administrator"
                            source="vdcm_url"
                            sortable={false} />
                        <TextField
                            label="Passphrase (double-click to select)"
                            source={"passphrase"}
                            sortable={false}/>
                        <NumberField
                            label="Minutes left"
                            source="time_left"
                            sortable={false}/>
                        <TextField
                            label="Status"
                            source={"DensityTestStatus"}
                            sortable={false} />
                        <ShowButton />
                        <SubmitButton/>
                    </Datagrid>
                </List>
            </Fragment>
        );
    }
}



const ConfigTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>Test Wizard</span>;
};


export default connect(
    undefined,
    { push }
)(ConfigList);